import { HalkbankLogo } from '@/components/halkbank/HalkbankLogo';
import { SsoModal } from '@/features/auth/SsoModal';

import { type VariantSettings } from './variantConfiguration';

export const halkbankConfig: VariantSettings = {
  WebsiteName: 'Halkbank',
  Logo: <HalkbankLogo />,
  LogoIconWhite: <HalkbankLogo fontSize={36} boxSize={9} />,
  SsoModal: <SsoModal />,
};
